import { Grid } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import { useState } from 'react';

import AddDriverIcon from '../../assets/svg/Plan/overview/AddDriverIcon';
import { useRetrieveActivePlan } from '../../hooks/plan/useRetrieveActivePlan';
import { DriversFromVehiclesDialog } from '../../pages/planner/plan-details/dialogs/DriversFromVehiclesDialog';

export const IconDriversCreateMenu = () => {
  const [routesFromVehiclesOpen, setRoutesFromVehiclesOpen] = useState<boolean | undefined>(false);
  const { data: activePlan } = useRetrieveActivePlan();
  const [isHover, setIsHover] = useState<boolean>(false);

  return (
    <>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        style={{
          border: `1px solid ${isHover ? RoutalPalette.secondary20 : RoutalPalette.secondary60}`,
          backgroundColor: isHover ? RoutalPalette.neutral05 : RoutalPalette.neutral00,
          width: `54px`,
          height: `32px`,
          borderRadius: `10px`,
          cursor: `pointer`,
        }}
        onClick={(e) => {
          e.stopPropagation();
          setRoutesFromVehiclesOpen(true);
        }}
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
      >
        <AddDriverIcon color={isHover ? RoutalPalette.secondary20 : RoutalPalette.secondary60} />
      </Grid>

      <DriversFromVehiclesDialog
        planId={activePlan!.id}
        open={Boolean(routesFromVehiclesOpen)}
        handleCloseDialog={(e: any) => {
          if (e) e.stopPropagation();
          setRoutesFromVehiclesOpen(false);
        }}
      />
    </>
  );
};
